var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form',{staticClass:"send-review-email",attrs:{"role":"form","name":"send-review-email"}},[_c('button',{staticClass:"btn btn-primary ladda-button",attrs:{"data-style":"zoom-in","type":"button"},on:{"click":_vm.onFormSubmit}},[_vm._v(_vm._s(_vm.$t('shop.order.sendReviewEwebmail.button')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }